import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

export default function GuestOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: 40, color: '#888' }}>Loading...</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
}
